module.exports = __webpack_public_path__ + "img/markets-firmenich.0dcacba2.jpg";